/* istanbul ignore file */
import { Ibh } from '@igus/iglidur-bearing-hub-api';
import { IBD } from '@hub/bearing-hub/config';

const headers = {
  'Kopla-Service-ID': IBD.koplaServiceId,
  'Api-Version': IBD.bearingHubApiVersion,
};
export const ibhApiService = new Ibh({ baseUrl: IBD.apiUrl, baseApiParams: { headers } });
